import type {Project} from '../Project.js'
import dayjs, {type Dayjs} from 'dayjs'

export const getUnarchiveTime = (project: Project): Dayjs | undefined => {
  if (!project.archivedTime) return undefined
  return dayjs(project.archivedTime).add(1, 'hour').startOf('minute')
}
